import React from "react";
import { CifradoAES, CifradoRSA } from "../../components/FuncionesCifrado";
import { BASE_URL } from "../../config/api";
import { withRouter } from "../../utils/withRouter";
class Sesion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formularioSesion:false,
      publicKeyRSA:'',
      correoInicioSesion: "",
      contrasenaInicioSesion: "",
      tokenSeguridadPeticion: "HsJ6NoqcoTG6ePWwQd7jWsDKrQd5AEwN5zQkXv4T2Kn7wZ3qZuJnLpjARNJG3HKtwm47Vb4vh2r42kRPegEEdwcZdry82SXhfGqhgLEaFWAGEofKDhuxX9dWB4aDErYA",
    }
    this.aesEncryption = new CifradoAES();
    this.rsaEncryption = new CifradoRSA();
    this.iniciarsesion = this.iniciarsesion.bind(this);
    /* this.navigate = new useNavigate();
    this.location = new useLocation(); */
  };
  componentDidMount() {
    /* if (sessionStorage.getItem("id_usuario") !== null) {
      window.location = "NeuroDrive.html";
      return;
    } */
    this.fetchPublicKey();

  }
  componentDidUpdate() {

  }
  fetchPublicKey = async () => {
      try {
          const formData = new FormData();
          const response = await fetch(`${BASE_URL}/cratos/ModuloSesion/PHP/Implementaciones/pedirLlavePublica.php`, {
              method: 'POST',
              body: formData,
          });
          
          if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const publicKey = await response.text();
          
          this.setState({ publicKeyRSA: publicKey });/* , () => {
              this.pedirPaquetes();
              this.obtenerServicios(); // Call after state is set
              
          }); */
          
      } catch (error) {
          console.error('Error fetching public key:', error);
          alert("Error Cifrado Asimetrico: " + error.message);
      }
  }
  async iniciarsesion() {
    try {
      const token = this.state.tokenSeguridadPeticion;
      const formData = new FormData();
      formData.append("correo", this.state.correoInicioSesion);
      formData.append("password", this.state.contrasenaInicioSesion);
      formData.append("t_seg", token);

      //Cifrando Envío
      for (let dato of formData.entries()) {
          formData.set(dato[0], this.aesEncryption.cifrar(dato[1]).datos)
      }
      let llaveCifrada = await this.rsaEncryption.cifrar(this.aesEncryption.llave, this.state.publicKeyRSA);
      formData.append("ivCifradoSimetrico", this.aesEncryption.iv);
      formData.append("keyCifradoSimetrico", llaveCifrada);

      const url = `${BASE_URL}/cratos/ModuloSesionDrive/PHP/Implementaciones/iniciarSesion.php`;
      const response = await fetch(url, {
          method: 'POST',
          body: formData,
      });
      
      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const res = await response.text();
      try {
          if (parseInt(res) != 0) {
              let datos = JSON.parse(res);
              sessionStorage.setItem("id_usuario", datos.id_usuario);
              sessionStorage.setItem("nombre", datos.nombre);
              sessionStorage.setItem("correo", datos.correo);
              sessionStorage.setItem("telefono", datos.telefono);
              sessionStorage.setItem("tipo_usuario", datos.tipo_usuario);
              sessionStorage.setItem("token_nk107803", datos.token_seguridad);
              //window.location = "NeuroDrive.html";
              /* this.setState({ paquetes: datos },()=>{
                  this.listarPaquetes();
              }); */
              // Redirect to the page they tried to access, or default to /drive
              this.props.router.navigate('/drive');
          }else {
            alert("Correo y/o Contraseña Incorrectos");
          }
      } catch (err) {
          alert("Error Sesion");
          console.error('Error:', err);
      }
    } catch (error) {
      console.error('Error fetching sesion:', error);
      alert("Error sesion: " + error.message);
    }
  }
 /*  cerrarSesion() {
    sessionStorage.clear();
    location.reload();
    //window.location = "sesion.html";
    console.log(window.location);
  }
   */
  render() {
    let salida = [];
    /* if(this.state.formularioSesion){
      salida = [];
      salida.push(<FormularioInicioSesion/>);
    }
    else{
      salida = []; */
      salida.push(<nav className="navbar navbar-expand-lg sticky-top border border-bottom navbgcolor">
        <div className="container">
          
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav col-lg-6 justify-content-lg-center">
              <li key={'aboutus'} className="nav-item">
                <a className="nav-link" aria-current="page" href="#">Nosotros</a>
              </li>
              <li key={'solutions'} className="nav-item">
                <a className="nav-link" href="#">Soluciones</a>
              </li>
              <li key={'pricing'} className="nav-item">
                <a className="nav-link" href="#">Planes</a>
              </li>
            </ul>
            
          </div>
          <a className="navbar-brand fs-3" href="#">
            <img src="../img/logo_blanco.svg" width={50} height={50}/>
          </a>
          {/* <div className="d-lg-flex col-lg-3 justify-content-lg-end">
            <a href="https://neurokratos.space/drive/iniciasesion.html" className="btn btn-outline-info me-2">Iniciar sesión</a>
            <button className="btn btn-info">Registrarse</button>
          </div> */}
        </div>
      </nav>);
      salida.push(<div className="container-fluid navbgcolor vh-100">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-8 mb-3 mt-auto">
              <img className="img-fluid" src="../img/InicioSesion.svg"/>
            </div>
            <div className="col-sm-12 col-md-4 my-3">
              <div className="row">
                <div className="col-12 mb-3 text-center">
                  <img src="../img/logo.svg" width={100} height={100}/>
                </div>
                <div className="col-12 mb-3">
                  <div className="form-floating mb-3">
                    <input type="email" className="form-control" id="correoInicioSesion" placeholder="nombre@ejemplo.com" onChange={(e)=>{
                      e.preventDefault();
                      this.setState({correoInicioSesion:e.currentTarget.value});
                    }}/>
                    <label htmlFor="correoInicioSesion">Correo electronico</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input type="password" className="form-control" id="contrasenaInicioSesion" placeholder="Contraseña" onChange={(e)=>{
                      e.preventDefault();
                      this.setState({contrasenaInicioSesion:e.currentTarget.value});
                    }}/>
                    <label htmlFor="contrasenaInicioSesion">Contraseña</label>
                  </div>
                  <a className="float-end text-secondary text-decoration-none" href="#"><small>¿Has olvidado tu contraseña?</small></a>
                </div>
                <div className="col-12 mb-3">
                  <div className="d-grid gap-2">
                    <button className="btn btn-entrar btn-lg text-white fs-4" type="button" onClick={this.iniciarsesion}>Entrar</button>
                  </div>
                </div>
                <div className="col-12 mb-3 text-center">
                  <hr/>
                  <span className="fs-5 text-secondary">¿No tienes una cuenta?</span> <a className="fs-5 link-azul text-decoration-none" href="#">Regístrate</a>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              <div className="justify-content-center">
                <a style={{ color: "black" }} href="#"> Declaración de Privacidad</a>|
                <a style={{ color: "black" }} href="#"> Términos de Uso</a>|
                <a style={{ color: "black" }} href="#"> Preferencias de Cookies</a>|
                <a style={{ color: "black" }} href="#"> Soporte Técnico</a>
              </div>
              <div className=" justify-content-center">
                ©Neurokratos. Todos los derechos reservados
              </div>
            </div>
          </div>
        </div>
      </div>);
    //}
    return (salida);
  }
}
export default withRouter(Sesion);